import dvaModelExtend from 'dva-model-extend';

import { bindServices } from '@/services/api';
import { createCrudModel } from '@/utils/core/dva';

const api = bindServices('dashboard');

/** Acepta arrays u OData `{ items: [] }`. */
const toArray = (v) => {
  if (v == null) return [];
  if (Array.isArray(v)) return v;
  if (typeof v === 'object' && Array.isArray(v.items)) return v.items;
  return [];
};

const firstDefined = (o, keys) => {
  if (o == null) return undefined;
  for (let i = 0; i < keys.length; i += 1) {
    const v = o[keys[i]];
    if (v !== undefined && v !== null) return v;
  }
  return undefined;
};

const buildState = () => {
  const now = new Date();
  return {
    currentYear: now.getFullYear(),
    currentMonth: now.getMonth() + 1,
    managementBox: {
      planRequestsCount: 0,
      planTotalSpace: 0,
      spaceUsed: 0,
      totalEnabledProcess: 0,
      totalEnabledUsers: 0,
      totalProcess: 0,
      totalRequestsCount: 0,
      totalUsers: 0,
      aiConsumptions: [],
    },
    mostUsedProcess: [],
    requests: {
      totalApprovedRequests: 0,
      totalCanceledRequests: 0,
      totalPendingRequests: 0,
      totalReceivedRequests: 0,
      totalRejectedRequests: 0,
      totalRequests: 0,
      totalSentRequests: 0,
      totalVoidedRequests: 0,
    },
    lastSentRequests: [],
    lastSentTasks: [],
    pendingTasks: [],
    requestsByMonth: [],
    mainCollaborators: [],
  };
};

const _model = createCrudModel({
  namespace: 'dashboard',
  features: { crud: false },
  state: buildState(),
  effects: {
    *init({ payload }, { call, put }) {
      try {
        const response = yield call(api.getAll, { route: 'dashboard', ...payload });
        yield put({
          type: 'queryBoard',
          payload: { ...payload, response },
        });
      } catch (e) {}
    },

    *resetCurrentYearMonth(__, { put }) {
      yield put({ type: 'queryCurrentYearMonth' });
    },
  },
  reducers: {
    /** Volver al vacío (p. ej. al cambiar empresa/entorno) para no mezclar tenants. */
    reset() {
      return buildState();
    },

    queryBoard(state, { payload }) {
      const { month, year, response: raw } = payload;
      const r = raw || {};

      // El API suele devolver `lastSentTasks` (y a veces PascalCase); el UI lee `lastSentRequests`.
      const lastList = toArray(
        firstDefined(r, ['lastSentRequests', 'lastSentTasks', 'LastSentRequests', 'LastSentTasks']),
      );
      const pendingList = toArray(
        firstDefined(r, [
          'pendingTasks',
          'userPendingTasks',
          'userPendingTaskItems',
          'pendingUserTasks',
          'PendingTasks',
          'UserPendingTasks',
        ]),
      );

      return {
        ...state,
        ...r,
        lastSentRequests: lastList,
        lastSentTasks: lastList,
        pendingTasks: pendingList,
        currentYear: year,
        currentMonth: month >= 0 ? month : 'all',
      };
    },

    queryCurrentYearMonth(state) {
      const t = new Date();
      return {
        ...state,
        currentYear: t.getFullYear(),
        currentMonth: t.getMonth() + 1,
      };
    },
  },
});

export default dvaModelExtend(_model, { namespace: 'dashboard' });
